import { Injectable } from '@angular/core';
import { WipperozApiService } from 'app/wipperoz-core/services/wipperoz-api.service';
import { BehaviorSubject } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { Faq } from 'app/wipperoz-core/types/pricing/faq.model';
import { filter } from 'rxjs/operators';
import { IpLocationService } from 'app/wipperoz-core/services/ip-location.service';
import { Product } from 'app/wipperoz-core/types/pricing/product.model';
import { WipperozGeolocationService } from 'app/wipperoz-core/services/location.service';
import { LoggingService } from 'app/wipperoz-core/services/logging.service';

@Injectable({
  providedIn: 'root'
})
export class PricingService {
  products: Product[];
  faqs: Faq[];
  language = 'EN';
  currency = '';
  countryCode = 'Overseas';
  onFaqsChanged: BehaviorSubject<any>;
  onPricingChanged: BehaviorSubject<any>;

  constructor(
    private _wipperozApiService: WipperozApiService,
    private _ipLocationService: IpLocationService,
    private locationService: WipperozGeolocationService,
    private loggingService: LoggingService
  ) {
    this.onFaqsChanged = new BehaviorSubject<any>(null);
    this.onPricingChanged = new BehaviorSubject<any>(null);
  }

  getFaqs(): Promise<any> {
    let params = new HttpParams();
    this.language = this.locationService.language;

    params = params.append('language', this.language);
    return new Promise((resolve, reject) => {
      this._wipperozApiService
        .get<Faq>('/pricing/landing/faq', params)
        .pipe(filter((response: any) => response !== undefined && response.count > 0))
        .subscribe(
          (response: any) => {
            if (response !== undefined && response !== null) {
              if (response.count !== 0) {
                this.faqs = [];
                response.items.forEach((element) => {
                  this.faqs.push(element);
                });
              }
              this.onFaqsChanged.next(this.faqs);
              resolve(this.faqs);
            }
          },
          (err) => {
            this.loggingService.logError('getFaqs error', JSON.stringify(err));
            resolve(reject);
          }
        );
    });
  }

  getPlans(): Promise<any> {
    if (this._ipLocationService.ipLocation !== undefined) {
      this.currency = this._ipLocationService.ipLocation.currencyCode.toLowerCase();
      this.countryCode = this._ipLocationService.ipLocation.countryCode.toLocaleUpperCase();
    } else {
      this.currency = 'usd';
    }

    if (this.currency !== undefined && this.currency !== '') {
      let params = new HttpParams();
      params = params.append('currency', this.currency);
      params = params.append('countryCode', this.countryCode);

      return new Promise((resolve, reject) => {
        this._wipperozApiService
          .get<Product>('/pricing/landing/subscription', params)
          .pipe(filter((response: any) => response !== undefined))
          .subscribe(
            (response: any) => {
              if (response !== undefined) {
                this.products = [];
                response.forEach((element) => {
                  const tmp = new Product(element.product);
                  this.products.push(tmp);
                });
                this.products.map((elem) => {
                  elem.prices.sort((a, b) => a.metadata.order - b.metadata.order);
                });
                this.onPricingChanged.next(this.products);
                resolve(this.products);
              }
            },
            (err) => {
              this.loggingService.logError('getPlans error', JSON.stringify(err));
              reject(null);
            }
          );
      });
    }
  }
}
